import React from "react";
import { Box, useTheme } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { getTypeColor, getReadStatusColor } from "../../../../constants/colors";

/**
 * 単価/年収＋金額（数値部分を強調）
 */
const IndexCardPriceRow = ({ type, isNew, priceMin, priceMax }) => {
  const theme = useTheme();

  // job/project 用の共通設定
  const style = {
    color: getTypeColor(type),
    label: type === "job" ? "年収 " : "単価 ",
  };

  // 共通カラー作成（未読＝黒、既読＝薄いグレー）
  const textColor = getReadStatusColor(theme, isNew);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
      <MonetizationOnIcon
        sx={{ fontSize: { xs: 12, sm: 16 }, color: style.color }}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
        {/* 年収 or 単価 */}
        <Box
          sx={{
            fontSize: { xs: "0.7rem", sm: "0.8rem" },
            color: textColor,
          }}
        >
          {style.label}
        </Box>

        {/* 最小金額 */}
        <Box
          component="span"
          sx={{
            color: style.color,
            fontSize: { xs: "0.8rem", sm: "1rem" },
            fontWeight: "bold",
          }}
        >
          {priceMin}
        </Box>

        {/* 〜 */}
        <Box
          sx={{
            fontSize: { xs: "0.7rem", sm: "0.8rem" },
            color: textColor,
          }}
        >
          〜
        </Box>

        {/* 最大金額 */}
        <Box
          component="span"
          sx={{
            color: style.color,
            fontSize: { xs: "0.8rem", sm: "1rem" },
            fontWeight: "bold",
          }}
        >
          {priceMax}
        </Box>

        {/* 万円 */}
        <Box
          sx={{
            fontSize: { xs: "0.7rem", sm: "0.8rem" },
            color: textColor,
          }}
        >
          万円
        </Box>
      </Box>
    </Box>
  );
};

export default IndexCardPriceRow;
